<template>
  <v-btn color="primary" width="167px" dark outlined @click="onExport">
    <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
  </v-btn>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import { CONFIG_KEYS, EXPORT_FIELDS, displayDataInConfigs } from '../../helpers'
import { setColumnWidths } from './utils'
export default {
  computed: { ...mapGetters({ configs: 'leadConfig/configs' }) },
  methods: {
    ...mapActions({ getLeadsExcel: 'lead/fetchLeadIndependent' }),
    formatDataForExport(data) {
      return data.map(item => {
        let formattedItem = {}
        for (let key in EXPORT_FIELDS) {
          const fieldInfo = EXPORT_FIELDS[key]
          let value = item

          const fieldPath = typeof fieldInfo === 'string' ? fieldInfo : fieldInfo.field
          const pathParts = fieldPath.split('.')
          pathParts.forEach(part => {
            if (value) {
              value = value[part]
            }
          })

          if (typeof fieldInfo === 'object' && fieldInfo.callback) {
            value = fieldInfo.callback(value)
          }

          formattedItem[key] = value || ''

          if (value) {
            if (key === 'Số điện thoại') {
              formattedItem[key] = { v: value, t: 's' }
            } else if (key === 'Hình thức theo học') {
              formattedItem[key] = displayDataInConfigs({
                configs: this.configs,
                type: CONFIG_KEYS.STUDENT_LEARNING_METHOD,
                separator: ' // ',
                valuePrefix: '',
                data: value,
              })
            } else if (key === 'Khóa học muốn tham gia') {
              formattedItem[key] = displayDataInConfigs({
                configs: this.configs,
                type: CONFIG_KEYS.STUDENT_PRODUCT,
                separator: ' // ',
                valuePrefix: '',
                data: value,
              })
            } else if (key === 'Cơ sở đăng ký') {
              formattedItem[key] = displayDataInConfigs({
                configs: this.configs,
                type: CONFIG_KEYS.STUDENT_DEPARTMENT,
                separator: ' // ',
                valuePrefix: '',
                data: value,
              })
            }
          }
        }
        return formattedItem
      })
    },
    async onExport() {
      this.$loading.active = true
      const leads = await this.getLeadsExcel({ isArchived: 'false', _limit: -1 })
      const formattedData = this.formatDataForExport(leads)
      const worksheet = XLSX.utils.json_to_sheet(formattedData)

      setColumnWidths(worksheet, formattedData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads')
      XLSX.writeFile(workbook, 'danh-sach-khach-hang.xlsx')
      this.$loading.active = false
    },
  },
}
</script>